export const whyChooseZutoCards = [
    { title: "£0 Deposit Options", description: "Many of our lenders offer zero deposit options to help spread the cost." },
    { title: "Providing car finance since 2006", description: "Over 5.3 million customers have trusted Zuto." },
    { title: "Wide range of lenders", description: "We have over 275 finance options available from over 16 lenders." },
    { title: "Expert Advice", description: "Our team of car finance experts provide advice and guidance throughout the whole car buying process." },
    { title: "Flexible Terms", description: "We offer flexible finance options including repayment terms tailored to your individual circumstances." },
    { title: "Convenience", description: "Our easy online application process means you can start the car finance process anywhere." }
]

export const faqAccordionItems = [
    { title: "Do I need a deposit to be accepted?", content: "No, a deposit could be beneficial but many lenders may still approve you without one." },
    { title: "Can I get car finance if I have bad credit?", content: "Yes, we can help people with a less-than-perfect credit history. You may find that you're not offered the great rates that someone with excellent credit history might get, but we may still be able to help you find a finance option to suit your circumstances." },
    { title: "What is car finance?", content: "Car finance is a way for you to buy a new or used car by spreading the cost over a period of months. So, instead of having to pay everything upfront, you can split the cost into manageable amounts that are paid in regular monthly instalments." }
]

export const howZutoWorksTiles = {
    tile1: {
        icon: "https://cdn.zuto.cloud/assets/images/icons/pointer-icon.svg",
        iconAlt: "Apply Online",
        headingText: "Apply Online",
        bodyText: "Using our simple application form, we will need a few details to provide a personalised quote."
    },
    tile2: {
        icon: "https://cdn.zuto.cloud/assets/images/icons/file-icon.svg",
        iconAlt: "Compare Finance",
        headingText: "Compare Finance",
        bodyText: "We'll search our panel of lenders to find the best deal to suit your needs."
    },
    tile3: {
        icon: "https://cdn.zuto.cloud/assets/images/icons/car-2-icon.svg",
        iconAlt: "Car icon",
        headingText: "Choose your car",
        bodyText: "We'll run a free vehicle and history check for you to give you peace of mind."
    },
    tile4: {
        icon: "https://cdn.zuto.cloud/assets/images/icons/car-icon.svg",
        iconAlt: "Car icon",
        headingText: "Drive Away",
        bodyText: "We'll take care of everything with the lender and arrange payment so all you need to do is collect the car."
    }
}
